import type { RunProjection } from "@roboscientist/contracts";

export type ComparisonMetricAvailability = "available" | "waiting" | "missing";

export const comparisonMetricAvailability = (
  run: RunProjection,
  availableNames: ReadonlySet<string>,
  metric: string
): ComparisonMetricAvailability => {
  if (availableNames.has(metric)) return "available";
  const active = run.status === "active" || run.status === "running";
  if (active && (run.primaryMetricName === metric || (!run.capabilities.metrics && run.capabilities.metricsDeclared))) return "waiting";
  return "missing";
};
